"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessibilityProps = void 0;
const react_native_1 = require("react-native");
exports.accessibilityProps = (id, accessibilityHint) => {
    return react_native_1.Platform.OS === 'android'
        ? { accessibilityLabel: id || '', accessibilityHint }
        : { testID: id };
};
